export function filterNullOrUndefined() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var result = {};
  Object.keys(data).forEach(function (key) {
    if (data[key] !== null && data[key] !== undefined) {
      result[key] = data[key];
    }
  });
  return result;
}